import React from "react";
import ReactDOM from "react-dom";
import App from "./config/App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import "./i18n";

import store from "./redux/store";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
reportWebVitals();
